/**
 * The menu cursor: the font's diamond spinning about its vertical axis, like a gem on a string
 * (04 §7). Drawn row by row so every frame stays in the C64 palette.
 */

import { ORANGE, WHITE, YELLOW } from '../../render/palette';
import type { Screen } from '../../render/screen';

/** The diamond glyph's row widths, top to bottom (see fontSymbols '◆'). */
const ROWS = [2, 4, 6, 8, 6, 4, 2];
const TURN_MS = 1100;

/** The spin at time `ms`: how wide (0..1) and which face shows. Pure. */
export function spinPhase(ms: number): { width: number; front: boolean } {
  const a = ((ms % TURN_MS) / TURN_MS) * Math.PI * 2;
  const c = Math.cos(a);
  return { width: Math.abs(c), front: c >= 0 };
}

/** A spinning diamond with its top-left at (x, y), 8 x 7 pixels. */
export function drawSpinner(screen: Screen, x: number, y: number, ms: number, colour = YELLOW, back = ORANGE): void {
  const { width, front } = spinPhase(ms);
  const edge = width < 0.3;
  const col = edge ? WHITE : front ? colour : back;
  ROWS.forEach((full, row) => {
    const w = Math.max(2, 2 * Math.round((full * width) / 2));
    screen.fill(x + 4 - w / 2, y + row, w, 1, col);
  });
  // A glint on the face's upper left while it faces us.
  if (front && width > 0.7) screen.fill(x + 3 - Math.round(width), y + 2, 1, 1, WHITE);
}

/** A ► that nudges right and back, for "go" buttons and the selected option. */
export function drawPointer(screen: Screen, x: number, y: number, ms: number, colour = YELLOW): void {
  const dx = Math.round(Math.max(0, Math.sin(ms / 140)) * 2);
  screen.text('►', x + dx, y, colour);
}
